'use es6';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
import { getUpgradeModalForModuleType } from 'EmailEditorUI/utils/moduleUtils';
import { getModuleType } from 'EmailData/constants/DefaultModulesConstants';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const ScopedModuleMessage = ({
  moduleId,
  openModalAction
}) => {
  const moduleType = getModuleType(moduleId);
  if (!moduleType) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.elements.scopedModuleInUseMessages.default"
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `layoutBuilder.elements.scopedModuleInUseMessages.${moduleType}`,
    options: {
      link: /*#__PURE__*/_jsx(Link, {
        onClick: () => openModalAction(getUpgradeModalForModuleType(moduleType)),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "layoutBuilder.elements.upgradeNowLink"
        })
      })
    },
    elements: {
      Link
    }
  });
};
ScopedModuleMessage.propTypes = {
  moduleId: PropTypes.number.isRequired,
  openModalAction: PropTypes.func
};
export default connect(null, {
  openModalAction: openModal
})(ScopedModuleMessage);